module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Bern_matt-e6ceddf125eaae99e04274103c1b4f07.svg";